import * as Yup from 'yup'
import { getIn, useFormikContext } from 'formik';
import { isPopulatedArray } from '../../../../../../components/helpers';
import { FormikDateSelector, FormikFileUpload, FormikSelect } from '../../../../../../components/widgets';
import { DLMCreateROIButton } from '../../../widgets/DLMCreateROIButton';
import { useDLMResponseFormContext } from '../../components';
import { useUserLoader } from '../../../../../core/users';

export const DLMAdminReviewSitesSchema: any = Yup.object().shape({
  siteApplicationId: Yup.number().integer(),
  inspectionDate: Yup.string().trim().label('Inspection Date').required(),
  inspectorID: Yup.number().integer().label('Inspector').required(),
  roiModels: Yup.array().of(
      Yup.object().shape({
          roiId: Yup.number().integer().label('ROI Id'),
          roiAttachmentId: Yup.number().integer().moreThan(0,'ROI required').required().label('ROI Attachment'),
          roiAttachmentIdAttachmentName: Yup.string().trim(),
      })
  ).min(1, 'ROI Required').required(),    
})

export const DLMAdminReviewSitesList = () => {

  const { setBaseROI, generateROI } = useDLMResponseFormContext();

  const { data: inspectors } = useUserLoader({userType: 'DLM Inspector'});
  
  const { values, validateField } = useFormikContext();
  const sites = getIn(values, 'sites');

  if (! (isPopulatedArray(sites))) {
    return null;
  }


  
  return (
  <div className='table-responsive mh-200px'>
    <table className='table align-middle table-row-bordered table-row-gray-300 fs-7 gy-2 dataTable no-footer' >
      <thead>
        <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
          <th className="p-2">Project</th>
          <th className="p-2 text-center">Inspector / Inspection Date</th>          
          <th className="p-2 text-center">Upload ROI</th>
        </tr>
      </thead>
      <tbody className='text-gray-800 align-middle fs-7'>
      { sites.map((site: any, idx: number) => (
        <tr key={`siteItemDetailRow${idx}`}>
          <td className="px-2 pt-3 align-top">
            {`${site.projectName}`}
          </td>
          <td className="p-1 align-top">            
            <div className="mw-300px">              
              <FormikSelect size="12"  name={`sites.${idx}.inspectorID`} required={true} options={inspectors} placeholder='Select Inspector' />            
              <FormikDateSelector size="12" name={`sites.${idx}.inspectionDate`} required={true} showShiftSelector={true} dateFormat='L' asRow />              
            </div>            
          </td>
          <td className="py-1 align-top">
            { (site?.roiModels && site.roiModels.length > 0) ? (
             <div className="mh-250px overflow-auto pe-4"> {
              site.roiModels.map((roiModel: any, ridx: number) => (
                <div key={`setROIrow_${idx}_${ridx}`} className="row">
                  <FormikFileUpload 
                    size="9" 
                    label={`[${roiModel?.cbRef ? roiModel.cbRef : `${roiModel.series}${roiModel.no}${roiModel?.split ? roiModel?.split :''}`}] ${roiModel.projectName}`}
                    name={`sites.${idx}.roiModels.${ridx}.roiAttachmentId`} 
                    acceptFiles="UserFileFormats" 
                    required={true}   
                    disabled={getIn(values, `sites.${idx}.roiModels.${ridx}.roiId`) ? false : true} 
                    subTitle={getIn(values, `sites.${idx}.roiModels.${ridx}.roiId`) ? "Upload ROI here" : "Generate ROI first."}     
                    onUpdateFunc={ () => {
                      validateField(`sites.${idx}.roiModels`);
                      validateField('sites');
                    }}                   
                  />
                  <div className="col-3">
                    <button
                      type="button"
                      className='btn btn-sm btn-light-secondary py-1 mt-2 px-3'
                      onClick={() => {
                          setBaseROI(roiModel);
                          generateROI();
                      }}        
                    >
                      <span className='indicator-label'>Generate ROI</span>        
                    </button>
                  </div>              
                </div>
              ))}
            </div>            
            ) : (
            <DLMCreateROIButton siteID={site.siteApplicationId} srcField={`sites.${idx}.roiModels`} />
            )}             
          </td>
        </tr>
        ))
      }
      </tbody>
    </table>
  </div>
  );
}